// Psychologist/Favorites/FavoritesPsychologists.tsx

import React, {useCallback, useContext} from 'react';
import {IPsychologist} from '../../../Types/psychology/psychologist';
import {axios, DOMAIN_URL} from 'Auth/axiosConfig';
import {FC, FRC} from 'WideLayout/Layouts';
import Button from "Core/components/elements/Button/Button";
import {useNavigate} from "react-router-dom";
import {useErrorProcessing} from 'Core/components/ErrorProvider';
import {FavoritesContext} from "Psychologist/Favorites/FavoritesContext";
import PsychologistListWrapper from "Psychologist/PsychologistListWrapper";
import pprint from "../../../Utils/pprint";
import Head from "Core/components/Head";

interface FetchFavoritesResponse {
    results: IPsychologist[];
    count: number;
    next: string | null; // Если API поддерживает пагинацию, иначе null
}

interface FavoritePsychologistsProps {
    containerRef?: React.RefObject<HTMLDivElement>;
}

const FavoritePsychologists: React.FC<FavoritePsychologistsProps> = ({containerRef}) => {
    const navigate = useNavigate();
    const {byResponse} = useErrorProcessing();
    const {favoritePsychologists} = useContext(FavoritesContext);

    // Функция для загрузки избранных психологов
    const fetchFavoritePsychologists = useCallback(async (page: number): Promise<FetchFavoritesResponse> => {
        // Убедимся, что список уникален
        const uniqueFavoriteIds = Array.from(new Set(favoritePsychologists));

        try {
            const response = await axios.post('/api/v1/psychologists/favorites/', {
                ids: uniqueFavoriteIds,
                page: page, // Если API поддерживает пагинацию
            });
            pprint('Favorite psychologists:');
            pprint(response.data)
            return {
                results: response.data.results
                    ? response.data.results
                    : response.data,
                count: response.data.count,
                next: response.data.next || null,
            };
        } catch (error) {
            byResponse(error);
            return {results: [], count: 0, next: null};
        }
    }, [favoritePsychologists, byResponse]);

    return (
        <><Head
            title={'Избранные психологи | Лайф Хелп'}
            description={'Помощь квалифицированных психологов от сервиса Лайф Хелп'}
            robots={'noindex, nofollow'}
            canonicalUrl={`${DOMAIN_URL}/psychologists/favorites`}
        />
            <PsychologistListWrapper
                containerRef={containerRef}
                fetchPsychologists={fetchFavoritePsychologists}
                emptyMessage={<FC g={1}>
                    <FRC mt={2}>Нет избранных психологов</FRC>
                    <Button
                        className={'text-nowrap w-min mx-auto px-4'}
                        onClick={() => navigate('/questionnaire/psychologists')}>
                        ПОДОБРАТЬ ПСИХОЛОГА
                    </Button>
                </FC>}
                showChatButton={false}
                classNameContainer="maxw-700px mx-auto w-100"
                classNameScrollBar="pt-3 pb-2 px-2 fr gap-2"/></>
    );
};

export default FavoritePsychologists;
